import { Box, Button } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { ChevronLeftSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { BiCtaNames } from '../../bi/types';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { useVerticalDrillInScreen } from './use-vertical-drill-in-screen';
export const VerticalsDrillInBottomSection = () => {
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    navigateBackToMainPanel
  } = useVerticalDrillInScreen();
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    flex: "0 0 auto",
    verticalAlign: "bottom",
    zIndex: "10"
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    padding: "SP3 16px"
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    prefixIcon: /*#__PURE__*/React.createElement(ChevronLeftSmall, null),
    priority: "secondary",
    skin: "standard",
    onClick: () => {
      biLogger.ctaClick({
        ctaName: BiCtaNames.BackToSiteView
      });
      navigateBackToMainPanel();
    }
  }, t('accessibility-wizard.verticals-drill-in.bottom-section.button'))));
};
//# sourceMappingURL=verticals-drill-in-bottom-section.js.map